<template>
    <div class="list-radio-item">
        <vs-list-item :class="{selected: item.checked == true, unselect: item.checked == false}">
            <!-- <vs-radio v-model="item.checked" vs-name="radio" :vs-value="item.checked" @click.native="changeStatusRadio(item)">
                <div class="title pl-4 font-bold text-2xl py-1">{{item.title}}</div>
                <div class="content pl-4 py-1">{{item.content}}</div>
            </vs-radio> -->
            <label class="vs-component con-vs-radio vs-radio-primary">
                <input name="radio" type="radio" class="vs-radio--input" :value="item.checked" @change="changeStatusRadio(item)">
                <span class="vs-radio">
                    <span class="vs-radio--borde"></span>
                    <span class="vs-radio--circle" style="position: relative;">
                        <!-- <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 stroke-current text-white font-bold" style="position: absolute; top: 4px; left: 0" v-if="item.checked"/> -->
                        <i class="vs-icon material-icons text-white rounded-full" style="position: absolute; top: 4px; left: 0; box-shadow: 0 0 1px 1px #fff; padding: 1px" v-if="item.checked">check</i>
                    </span>
                </span>
                <span class="vs-radio--label">
                    <div class="title pl-4 font-bold text-2xl py-1">{{item.title}}</div>
                    <div class="content pl-4 pb-1">{{item.content}}</div>
                </span>
            </label>
            <!-- <div class="flex align-center">
                <input name="radio" type="radio" :value="item.checked" @change="changeStatusRadio(item)">
                <label>
                    <div class="title pl-4 font-bold text-2xl py-1">{{item.title}}</div>
                    <div class="content pl-4 py-1">{{item.content}}</div>
                </label>
            </div> -->
        </vs-list-item>
    </div>
</template>

<script>
export default {
    name: 'list-radio-item',
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        temp: {
            get() {
                return this.item.title;
            },
            set() {
                // this.$emit("RadioChange", this.item.title);
            }
        }
    },
    methods: {
        changeStatusRadio(item) {
            // console.log(item.checked)
            item.checked = !item.checked;
            this.$emit('ChangeStatusRadio', item);
        },
    }
}
</script>

<style lang="scss">
    @import "@/assets/scss/vuexy/_variables";
    @import "@/assets/scss/custom/_variables";
    .list-radio-item {
        .vs-list--item {
            border-radius: 4px;
            .vs-list--slot {
                margin-left: 0.45rem;
                width: 100%;
                transition: 0.2s ease;
                label {
                    width: 100%;
                    .vs-radio--label {
                        width: 100%;
                        .title {
                            color: rgba($primary, 0.7);
                        }

                        .content {
                            opacity: 0.8;
                        }
                    }
                }
            }

            &:hover {
                background: rgba(0, 0, 0, 0.07);
                .vs-list--slot {
                    margin-left: 0.6rem;
                }
            }
        }

        .selected {
            position: relative;
            color: #fff;

            .title {
                color: #fff !important;
            }
            &::after {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border-radius: 4px;
                background: linear-gradient(90deg, rgba($primary, 1), rgba($primary, 0.7));
                z-index: -1;
                animation: animate-selected 0.15s linear;
            }
            @keyframes animate-selected {
                0% {
                    width: 0%;
                }
                25% {
                    width: 25%;
                }
                50% {
                    width: 50%;
                }
                75% {
                    width: 75%;
                }
                100% {
                    width: 100%;
                }
            }
        }

        .unselect {
            position: relative;
            &::after {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 0%;
                height: 100%;
                border-radius: 4px;
                background: linear-gradient(90deg, rgba($primary, 1), rgba($primary, 0.7));
                z-index: -1;
                animation: animate-unselect 0.15s linear;
            }
            @keyframes animate-unselect {
                0% {
                    width: 100%;
                }
                25% {
                    width: 75%;
                }
                50% {
                    width: 50%;
                }
                75% {
                    width: 25%;
                }
                100% {
                    width: 0%;
                }
            }
        }
    }
</style>
